import { useEffect, useState } from 'react';

import {
    IdCardWrapper,
    Header,
    IdCardText,
    ModuleTitle,
    ModuleHeader,
    Project,
    Ribbon,
    FastForwardLogo,
    SectionWrapper,
    TextualAndImageWrapper,
    ViewsAndLayoutImageAndTitleWrapper,
    SubMenusWrapper,
    PrintWrapper,
    PreparingForPrintingTitle,
    SectionTitle,
    DescriptionWrapper,
    ImageWrapper,
    CharacteristicsSectionWrapper,
    CharacteristicsAndModulesWrapper,
    CharacteristicsWrapper,
    CharacteristicTitle,
    CharacteristicValue,
    CharacteristicWrapper,
    ModuleImage,
    ModuleName,
    ModuleNameWrapper,
    ModulesWrapper,
    ModuleTsCode,
    ModuleWrapper,
    DescriptionTitle,
} from './styles';

import Description from '../Description';
import DocumentationList from '../DocumentationList';
import React, { useRef } from 'react';
import ReactToPrint, { PrintContextConsumer } from 'react-to-print';

import fastForwardLogo from '../../resources/fast4ward.png';
import ImageViewer from '../../components/ImageViewer';
import { useIdCard } from '../../screens/HomeScreen/context/idCard';
import { PrintContextProvider, usePrint } from './context';
import {CONTRACT_TYPE_OPTIONS, MOORING_SYSTEM_OPTIONS} from "../../config/enums";

const ProjectIdCardForPrint = ({ projectId }) => {
    console.log(projectId);
    const { projectIdCard: projectIdCardData, idCardImageArray, setPrintMode, setEditingCardTagId, setIsProjectIdCard } = useIdCard();
    const { printImagesStatusArr, setPrintImagesStatusArr } = usePrint();
    const [valueHasBeenSet, setValueIndicator] = useState(false);
    const componentToPrintRef = useRef();
    setIsProjectIdCard(true);

    useEffect(() => {
        setPrintImagesStatusArr(
            idCardImageArray.map((image) => {
                return {
                    imageId: image.imageId,
                    loadingStarted: false,
                    loadingFinished: false,
                };
            })
        );
        setValueIndicator(true);
    }, [idCardImageArray]);

    useEffect(() => {
        setEditingCardTagId(projectId);

        return () => {
            setEditingCardTagId(undefined);
        };
    }, [projectId]);

    if (!projectIdCardData || !valueHasBeenSet) {
        console.log('no data');
        return <div />;
    }
    console.log(projectIdCardData);

    let isReadyForPrint = printImagesStatusArr.every(
        (printImage) => !printImage.imageId || (printImage.loadingStarted && printImage.loadingFinished)
    );

    const getContractType = (contractType) => {
        if (contractType) {
            return CONTRACT_TYPE_OPTIONS.filter(t => t.value === contractType)[0].label;
        }
        return '';
    };

    const getMooringSystem = (mooringSystem) => {
        if (mooringSystem) {
            return MOORING_SYSTEM_OPTIONS.filter(t => t.value === mooringSystem)[0].label;
        }
        return '';
    };

    return (
        <PrintWrapper>
            {isReadyForPrint ? (
                <ReactToPrint
                    content={() => componentToPrintRef.current}
                    onAfterPrint={() => setPrintMode(false)}
                    documentTitle={`Project Id Card ${projectIdCardData.projectId}`}>
                    <PrintContextConsumer>
                        {({ handlePrint }) => {
                            setTimeout(() => {
                                handlePrint();
                            }, 100);
                            return <div />;
                        }}
                    </PrintContextConsumer>
                </ReactToPrint>
            ) : (
                <PreparingForPrintingTitle>FETCHING IMAGES FOR PRINTING, PLEASE WAIT...</PreparingForPrintingTitle>
            )}

            <IdCardWrapper ref={componentToPrintRef}>
                <Header>
                    <Ribbon />
                    <IdCardText>Project ID Card</IdCardText>
                    <Project>{projectIdCardData.projectName}</Project>
                    <FastForwardLogo src={fastForwardLogo} />
                </Header>

                <SectionWrapper>
                    <ModuleHeader>
                        <Ribbon />
                        <ModuleTitle>DESCRIPTION</ModuleTitle>
                    </ModuleHeader>
                    <TextualAndImageWrapper>
                        <DescriptionWrapper>
                            <Description description={projectIdCardData.description ?? ''} />
                            <DescriptionTitle>SBM scope of work</DescriptionTitle>
                            <Description description={projectIdCardData.scopeOfWork ?? ''} />
                        </DescriptionWrapper>
                        <ViewsAndLayoutImageAndTitleWrapper>
                            {
                                <ImageViewer
                                    imageId={idCardImageArray[0].imageId}
                                    containerStyle={{
                                        width: '100%',
                                        height: '230px',
                                        backgroundColor: 'inherit',
                                    }}
                                />
                            }
                        </ViewsAndLayoutImageAndTitleWrapper>
                    </TextualAndImageWrapper>
                </SectionWrapper>


                {/*<SubMenusWrapper>*/}
                    {/*<ImageWrapper>*/}
                        {/*<SectionTitle>General Arrangement:</SectionTitle>*/}
                        {/*<ImageViewer*/}
                            {/*imageId={idCardImageArray[1]?.imageId}*/}
                            {/*containerStyle={{*/}
                                {/*width: '100%',*/}
                                {/*height: '240px',*/}
                            {/*}}*/}
                        {/*/>*/}
                    {/*</ImageWrapper>*/}
                    {/*<ImageWrapper>*/}
                        {/*<SectionTitle>Process Overview:</SectionTitle>*/}
                        {/*<ImageViewer*/}
                            {/*imageId={idCardImageArray[2]?.imageId}*/}
                            {/*containerStyle={{*/}
                                {/*width: '100%',*/}
                                {/*height: '240px',*/}
                            {/*}}*/}
                        {/*/>*/}
                    {/*</ImageWrapper>*/}
                    {/*<ImageWrapper>*/}
                        {/*<SectionTitle>Field layout:</SectionTitle>*/}
                        {/*<ImageViewer*/}
                            {/*imageId={idCardImageArray[3]?.imageId}*/}
                            {/*containerStyle={{*/}
                                {/*width: '100%',*/}
                                {/*height: '240px',*/}
                            {/*}}*/}
                        {/*/>*/}
                    {/*</ImageWrapper>*/}
                {/*</SubMenusWrapper>*/}
                <CharacteristicsAndModulesWrapper>
                    <CharacteristicsWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>Project characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Contract type:</CharacteristicTitle>
                                <CharacteristicValue>{getContractType(projectIdCardData.contractType)}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Contract duration:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.contractDuration}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Mooring system:</CharacteristicTitle>
                                <CharacteristicValue>{getMooringSystem(projectIdCardData.mooringSystem)}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Integration yard:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.integrationYard}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr production risers:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.nrProductionRisers}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr gas risers:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.nrGasRisers}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr gas export risers:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.nrGasExportRisers}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Nr water risers:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.nrWaterRisers}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Hull dimensions (LxWxH):</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.hullDimensions} m</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Max POB:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.maxPob}</CharacteristicValue>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>Field characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Field name:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.fieldName}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Distance from shore:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.distanceFromShore} km</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Water depth:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.waterDepth} m</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Field specifics:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.fieldSpecifics}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Crude oil viscosity:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.crudeOilViscosity} °API</CharacteristicValue>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                        <CharacteristicsSectionWrapper>
                            <SectionTitle>FPSO characteristics:</SectionTitle>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Gas blanketing:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.gasBlanketing ? 'Yes' : 'No'}</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Storage capacity:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.storageCapacity} m3</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Oil production:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.oilProduction} bpd</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Water production:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.waterProduction} bpd</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Total liquid:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.totalLiquid} bpd</CharacteristicValue>
                            </CharacteristicWrapper>
                            <CharacteristicWrapper>
                                <CharacteristicTitle>Gas production:</CharacteristicTitle>
                                <CharacteristicValue>{projectIdCardData.gasProduction} MM scfd</CharacteristicValue>
                            </CharacteristicWrapper>
                        </CharacteristicsSectionWrapper>
                    </CharacteristicsWrapper>
                    <ModulesWrapper>
                        <SectionTitle>Modules:</SectionTitle>
                        {projectIdCardData.modules && projectIdCardData.modules.map(module =>
                            <ModuleWrapper key={module.tagId}>
                                <ModuleImage>
                                    <ImageViewer
                                        imageId={module.imageId}
                                        fullscreen={false}
                                        defaultLoaderSize={35}
                                        containerStyle={{
                                            width: '100%',
                                            height: '100%',
                                        }}
                                    />
                                </ModuleImage>
                                <ModuleNameWrapper>
                                    <ModuleTsCode>{module.tsCode}</ModuleTsCode>
                                    <ModuleName>{module.name}</ModuleName>
                                </ModuleNameWrapper>
                            </ModuleWrapper>
                        )}
                    </ModulesWrapper>
                </CharacteristicsAndModulesWrapper>

                <SectionWrapper>
                    <ModuleHeader>
                        <Ribbon />
                        <ModuleTitle>Documentation List</ModuleTitle>
                    </ModuleHeader>
                    <DocumentationList documents={projectIdCardData.documents} isProject={true}/>
                </SectionWrapper>

            </IdCardWrapper>
        </PrintWrapper>
    );
};

const ProjectIdCardForPrintWrapped = ({ projectId }) => (
    <PrintContextProvider>
        <ProjectIdCardForPrint projectId={projectId} />
    </PrintContextProvider>
);

export default ProjectIdCardForPrintWrapped;
